"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function List(_a) {
    var users = _a.users, sortField = _a.sortField, onSort = _a.onSort, onDelete = _a.onDelete;
    return react_1.default.createElement(storybook_1.Lists.List, { type: 'grid' },
        react_1.default.createElement(storybook_1.Users.ListHeader, { sortField: sortField, onSort: onSort }),
        users.data.map(function (user, index) {
            return react_1.default.createElement(storybook_1.Users.ListItem, { key: index, user: user, onDelete: onDelete });
        }));
}
exports.default = List;
List.propTypes = {
    /**
     * Current user session
     */
    users: prop_types_1.default.object,
};
List.defaultProps = {
    starred: false
};
